import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import DashboardCard from '../components/DashboardCard';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { subscribeUser } from "../pushNotification";
import { motion, AnimatePresence } from "framer-motion";
import SetPasswordModal from "../components/Account/SetPasswordModal";
import Slider from '../components/Slider/Slider';
import apiLinks from '../config/apiLinks.json';
import apiService from '../utils/apiService';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

const Home = () => {
  const { accessToken, autoLogin, FullName, user } = useAuth();
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [mustChangePassword, setMustChangePassword] = useState(false);
  const [show, setShow] = useState(false);
  const [isDenied, setIsDenied] = useState(false);
  const navigate = useNavigate();
  const [slides, setSlides] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const iconMap = {
    ReceiptLongOutlinedIcon: ReceiptLongOutlinedIcon,
    LocalShippingOutlinedIcon: LocalShippingOutlinedIcon,
  };
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const data = await apiService.get(
          `${apiLinks.baseUrl}${apiLinks.Settings.GetMenus}`,
          {},
          autoLogin
        );
        if (data.Menus && data.Menus.length > 0) {
          setMenuData(data.Menus);
        }
      } catch (error) {
        console.error("Error fetching menu:", error);
      }
    };

    fetchMenu();
  }, [accessToken]);
  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await apiService.get(
          `${apiLinks.baseUrl}${apiLinks.Slides.Get_HomeSlides}`,
          {},
          autoLogin
        );
        if (response) {
          setSlides(response.HomeSlides || []);
        }
      } catch (error) {
        console.error('Error fetching slides data:', error);
      } finally {

      }
    };
    fetchSlides();
  }, [accessToken]);
  useEffect(() => {
    const changedPassword = localStorage.getItem("changedPassword");
    if (changedPassword === "0") {
      setMustChangePassword(true);
    }
  }, [accessToken]);
  // Check notification permission on mount
  useEffect(() => {
    if (typeof Notification !== "undefined") {
      if (Notification.permission === "default") {
        setShow(true); // first-time ask
      } else if (Notification.permission === "denied") {
        setIsDenied(true); // show your custom blocked message
        setShow(true);
      }
    }
  }, []);


  const handleEnable = async () => {
    if (Notification.permission === "default") {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        setShow(false);
        subscribeUser();
      } else {
        setIsDenied(true); // user denied this time
      }
    } else if (Notification.permission === "denied") {
      // guide user to browser settings
      alert(
        "برای فعال کردن اعلان‌ها، لطفاً تنظیمات مرورگر خود را بررسی و دسترسی اعلان‌ها را فعال کنید."
      );
    }
    else {
      setShow(false);
    }
  };

  useEffect(() => {
    if (!accessToken) {
      autoLogin();
    }
  }, [accessToken]);

  return (
    <div className="home-dashboard">
      <AnimatePresence>
        {show && (
          <motion.div
            initial={{ opacity: 0, y: 80, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 50, scale: 0.95 }}
            transition={{ duration: 0.3 }}
            className="notification-modal"
          >
            <div style={{ fontWeight: 600, marginBottom: 12 }}>
              {isDenied
                ? "اعلان‌ها در مرورگر شما مسدود شده است"
                : "فعال کردن اعلان‌ها"}
            </div>
            <div style={{ fontSize: 14, color: "#6c757d", marginBottom: 16 }}>
              {isDenied
                ? "برای دریافت اطلاعیه‌ها، لطفاً دسترسی اعلان‌ها را در تنظیمات مرورگر فعال کنید."
                : "برای دریافت اطلاعیه‌های مهم، اعلان‌ها را فعال کنید."}
            </div>

            <button
              onClick={handleEnable}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "10px",
                border: "none",
                background: "#fbeaec",
                color: "#dc3545",
                cursor: "pointer",
              }}
            >
              {isDenied ? "رفتن به تنظیمات مرورگر" : "فعال کردن"}
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Welcome Section */}
      <div className="welcome-box animate-welcome small-container">
        <h4>{FullName} عزیز، خوش آمدید</h4>
        <p>
          از طریق داشبورد زیر می‌توانید به امکانات سامانه دسترسی داشته باشید.
        </p>
      </div>

      {/* Dashboard Grid */}
      <div className='small-container'>
        <div className="dashboard-grid mb-5">
          {menuData.map((menu, index) => {
            const IconComponent = iconMap[menu.Menu_Icon];

            return (
              <DashboardCard
                key={menu.Menu_Id}
                icon={IconComponent ? <IconComponent /> : <ReceiptLongOutlinedIcon />}
                title={menu.Menu_text}
                description={menu.Menu_Notification_Text}
                onClick={() =>
                  navigate(`/${menu.Menu_Controller?.toLowerCase()}`)
                }
                delay={index * 0.1}
              />
            );
          })}
        </div>
        <div className='home-slider pb-5'>
          <Slider slides={slides} />
        </div>
        {mustChangePassword && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="password-warning-box"
          onClick={() => setShowPasswordModal(true)}
        >
          <div className="password-warning-content">
            <div className="password-warning-icon">
              🔒
            </div>
            <div className="password-warning-text">
              لطفا در اسرع وقت رمز عبور خود را تعریف کنید
            </div>
          </div>
        </motion.div>
      )}
      </div>
      
      <SetPasswordModal
        open={showPasswordModal}
        onClose={() => { setShowPasswordModal(false); }}
        username={user?.username}
      />
    </div>
  );
};

export default Home;